import React from 'react';
import dynamic from 'next/dynamic';
import styles from './buttons-toggler.module.scss';
import { IconVariants } from 'core/generic/elements/icons';
import { lazily } from 'react-lazily';

type ButtonsTogglerProps = {
    id?: string;
    trueLabel: string;
    falseLabel: string;
    errorMessage: string;
	errorIcon?: IconVariants;
    value: boolean | undefined;
    onChange: (value: boolean | undefined) => void;
};

const Button = dynamic(() => import('core/generic/elements/button'), {
    ssr: false,
});

const { Error } = lazily(() => import('core/generic/elements/form'));

export const ButtonsToggler = ({
    id,
    trueLabel,
    falseLabel,
    value = undefined,
    errorMessage = '',
	errorIcon,
    onChange,
}: ButtonsTogglerProps) => {
    return (
        <>
            <div className={styles.buttons} id={id}>
                <Button
                    type="button"
                    label={trueLabel}
                    variant={value === true ? "primary" : "tertiary"}
                    className={styles.submitButton}
                    onClick={() => value === true ? onChange(undefined) : onChange(true)}
                />
                <Button
                    type="button"
                    label={falseLabel}
                    variant={value === false ? "primary" : "tertiary"}
                    className={styles.submitButton}
                    onClick={() => value === false ? onChange(undefined) : onChange(false)}
                />
            </div>
			{errorMessage && <Error text={errorMessage} icon={errorIcon} />}
        </>
    );
};
